module.exports = __webpack_public_path__ + "img/ringsize@2x.8810550.jpg";